export default __webpack_public_path__ + "svg/calendar/2025/0/mayo.svg?bc3ab928";